<template>
  <div>
    <a-breadcrumb separator="/">
      <a-breadcrumb-item :to="{ path: '/admin/projects' }">Projects</a-breadcrumb-item>
      <a-breadcrumb-item>New</a-breadcrumb-item>
    </a-breadcrumb>
    <a-row type="flex" class="area-header">
      <h1 v-if="!isEditMode">New Project</h1>
      <h1 v-else>Edit Project</h1>
    </a-row>

    <a-steps progressDot :current="activeStep" style="margin-bottom:30px;">
      <a-step title="Project-Infos" description @click.native="activeStep = 0"></a-step>
      <a-step title="Schema-Properties" description @click.native="activeStep = 1"></a-step>
      <a-step title="Booking-Properties" description @click.native="activeStep = 2"></a-step>
      <a-step title="Public-Properties" description @click.native="activeStep = 3"></a-step>
      <a-step title="Summary" description @click.native="activeStep = 4"></a-step>
    </a-steps>

    <div v-show="activeStep == 0">
      <a-form ref="form" :model="project" label-width="120px" label-position="right">
        <a-form-item label="Project name">
          <a-input v-model="project.name"></a-input>
        </a-form-item>
        <a-form-item label="Description">
          <a-input
            type="textarea"
            :rows="3"
            placeholder="Enter a brief internal description of the project"
            v-model="project.description"
          ></a-input>
        </a-form-item>
        <a-form-item label="Booth name">
          <a-input v-model="project.boothSettings.name" placeholder="Name of bookable elements"></a-input>
        </a-form-item>
      </a-form>
    </div>

    <div v-show="activeStep == 1">
      <a-form>
        <a-form-item label="Title Field">
          <a-select v-model="project.boothSettings.titleField" filterable placeholder="Select">
            <a-select-option
              v-for="prop in project.schemaBoothProperties"
              :key="prop.id"
            >{{ prop.label }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>

      <h2>Schema Booth properties</h2>
      <app-properties-editor
        v-if="loadCompleted"
        :properties="project.schemaBoothProperties"
        config-type="schema"
        @apply="updateProperties('schema', $event)"
      ></app-properties-editor>
    </div>

    <div v-show="activeStep == 2">
      <h2>Booking Booth properties</h2>
      <app-properties-editor
        v-if="loadCompleted"
        :properties="project.bookingBoothProperties"
        config-type="booking"
        @apply="updateProperties('booking', $event)"
      ></app-properties-editor>
    </div>

    <div v-show="activeStep == 3">
      <h2>Public Booth properties</h2>

      <a-form>
        <a-form-item label="Title Field from public data">
          <a-select
            v-model="project.boothSettings.titleFieldFromPublicData"
            filterable
            placeholder="Select"
          >
            <a-select-option
              v-for="prop in project.publicBoothProperties"
              :key="prop.id"
            >{{ prop.label }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <app-properties-editor
        v-if="loadCompleted"
        :properties="project.publicBoothProperties"
        config-type="public"
        @apply="updateProperties('public', $event)"
      ></app-properties-editor>
    </div>

    <div v-show="activeStep == 4">
      <a-button
        :loading="isLoading"
        type="primary"
        @click="save()"
      >{{ isEditMode ? 'Update' : 'Create' }}</a-button>
    </div>
  </div>
</template>

<script>
import AppPropertiesEditor from "@/components/property/Editor";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loadCompleted: false,
      activeStep: 0,
      isLoading: false,
      project: {
        name: "",
        description: "",
        boothSettings: {
          titleField: null,
          name: "Booth"
        },
        publicBoothProperties: [],
        schemaBoothProperties: [],
        bookingBoothProperties: []
      }
    };
  },
  methods: {
    updateProperties(type, eventValue) {
      this.$log.info("[project-edit] -> property changed", type, eventValue);
      this.$set(this.project, `${type}BoothProperties`, eventValue);
    },
    save() {
      this.isLoading = true;
      this.$store
        .dispatch(
          `project/${this.isEditMode ? "update" : "create"}`,
          this.project
        )
        .then(() => {
          this.isLoading = false;
          this.$router.push("/admin/projects");
        })
        .catch(() => {
          this.$message.error("Oops, something went wrong.");
          this.isLoading = false;
        });
    }
  },
  computed: {
    isEditMode() {
      return this.$route.params.id != "new";
    },
    ...mapGetters("layout", {
      layouts: "all"
    })
  },
  async created() {
    this.$store.commit("SET_IS_FETCHING", true);
    await this.$store.dispatch("datasource/fetchAll");

    if (this.isEditMode) {
      const project = await this.$store.dispatch("project/fetchSingle", {
        id: this.$route.params.id
      });
      if (!project.publicBoothProperties) {
        project.publicBoothProperties = [];
      }
      this.$set(this, "project", project);
    }

    this.loadCompleted = true;

    this.$store.commit("SET_IS_FETCHING", false);
  },
  // async beforeRouteEnter(to, from, next) {
  //   if (to.params.id) {
  //     const project = await this.$store.dispatch("project/fetchSingle", {
  //       id: to.params.id
  //     });
  //     next(vm => {

  //     })
  //   }
  // },
  components: {
    AppPropertiesEditor
  }
};
</script>

<style lang="scss">
</style>
